/**
 * The little uppercase heading that separates the column into its two bands —
 * Catalog and Resources. It is the one thing the icon rail cannot show (it falls
 * back to a divider there), so the expanded column is where section names
 * actually do their work, and they sit a clear step below the rows
 * they introduce: `text-xs` medium at 46%. They are signposts, not destinations,
 * and there are only two of them — once you have seen where Catalog ends and
 * Resources begins you are reading the rows, not the headings.
 *
 * 46% is the floor: composited on the navy it measures 4.51:1, and WCAG AA for
 * normal text wants 4.5:1 — /45 already fails. Any further recession has to
 * come out of size or tracking, not opacity.
 */
export function ColumnSection({ label }: { label: string }) {
  return (
    <p className='select-none pl-2.5 pt-3.5 pb-1.5 text-xs font-medium uppercase tracking-widest text-sidebar-foreground/46'>
      {label}
    </p>
  );
}
